<template>
  <div class="vue-wrapper">
    <form autocomplete="off" @submit.prevent="handleSearchSubmit" style="width:100%; display: inline-flex; margin-left: 0.75rem;">
      <TheAutoCompleteInput
        containerClassName="no-class"
        name="Auksjon"
        maxlength="10"
        ref="auksjonInput"
        v-model.trim="form.Auksjon"
        :placeholder="'Velg auksjon'"
        :label="''"
        :onInputCallback="onAuksjonSearchInput"
        :onSelectCallback="onAuksjonSearchSelected"
        :debounce="750"
        :minquery="2"
        :disabled="isAuctionDisabled"
      >
        <div slot="item" slot-scope="props">
          <strong>{{props.item.Auksjon}}</strong>, {{props.item.Beskrivelse}}
          <span v-if="props.item.Auksjon_dato">
            ({{ props.item.Auksjon_dato | avantidate }})
          </span>
        </div>
      </TheAutoCompleteInput>
      <button v-if="!isFormDisabled" class="button small primary disabled">Søk</button>
      <button v-else type="submit" class="button small primary">Søk</button>
    </form>

    <span class="divider"></span>

    <a href="javascript:;" @click="exportCsv()" title="Eksporter CSV" class="button action small glyph glyph-only">
      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-spreadsheet"></use></svg>
    </a>
  </div>
</template>

<script>
import bus from '@/plugins/event-bus'
import draggable from 'vuedraggable'
import AuksjonService from '@/services/AuksjonService'
import TheAutoCompleteInput from '../../../Inputs/TheAutoCompleteInput'

export default {
  name: 'TheSpaderTopbar',
  components: {
    draggable,
    TheAutoCompleteInput
  },
  data () {
    return {
      dropdowns: {
        auksjon: []
      },
      form: {
        Avdelingsid: 0,
        Auksjon: null
      }
    }
  },
  created () {
    this.loadNextClassical()
  },
  computed: {
    columns: function () {
      return this.$store.getters['spader/columns']
    },
    isAuctionDisabled: function () {
      return this.form.Avdelingsid === '' || this.form.Avdelingsid === null
    },
    isFormDisabled: function () {
      return !!this.form.Auksjon
    }
  },
  methods: {
    loadNextClassical: function () {
      bus.$emit('spader-reset')

      AuksjonService.getNextClassical()
        .then(response => {
          if (response.data.Auksjon) {
            this.form.Auksjon = response.data.Auksjon
            this.handleSearchSubmit()
          }
        })
        .catch(error => {
          console.log('Error', error)
        })
    },
    onAuksjonSearchInput: function (query) {
      return AuksjonService.search(query, this.form.Avdelingsid)
    },
    onAuksjonSearchSelected: function (item) {
      this.form.Auksjon = item ? item.Auksjon : null
    },
    handleSearchSubmit: function () {
      bus.$emit('spader-start', { code: this.form.Auksjon })
    },
    exportCsv: function () {
      bus.$emit('spader-export')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Auctions/Spader/TheTopbar.vue